/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest =
  {
    ledgerCanisterId: string;
  };

/** @internal */
export const GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest$inboundSchema:
  z.ZodType<
    GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest$Outbound =
  {
    ledger_canister_id: string;
  };

/** @internal */
export const GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest$outboundSchema:
  z.ZodType<
    GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest$Outbound,
    z.ZodTypeDef,
    GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest$ {
  /** @deprecated use `GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest$inboundSchema;
  /** @deprecated use `GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest$outboundSchema;
  /** @deprecated use `GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest$Outbound` instead. */
  export type Outbound =
    GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest$Outbound;
}

export function getCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequestToJSON(
  getCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest:
    GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest,
): string {
  return JSON.stringify(
    GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest$outboundSchema
      .parse(
        getCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest,
      ),
  );
}

export function getCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetCirculatingSupplyTxtApiV1LedgersLedgerCanisterIdCirculatingSupplyTxtGetRequest' from JSON`,
  );
}
